import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, UncontrolledDropdown } from "reactstrap";
import axios from 'axios';
import { BASE_URL, checkPermission, USER_PERMISSIONS } from "../../../constants";
import AddInspectionPopup from "./AddInspectionPopup";

let apiTimeoutId = null;

function Inspection() {
	const [inspections, setInspections] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [perPage, setPerPage] = useState(5);
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [errMsg, setErrMsg] = useState(null);
	const navigate = useNavigate();
	const { search } = useLocation();
	const params = new URLSearchParams(search);
	const [searchQuery, setSearchQuery] = useState("");
	const [createInspection, setCreateInspection] = useState(false);

	useEffect(() => {
		if (apiTimeoutId) clearTimeout(apiTimeoutId);

		apiTimeoutId = setTimeout(() => {
			fetchData();
		}, 500);
	}, [currentPage, perPage, search, searchQuery, createInspection]);

	const toggleDropdown = () => {
		setDropdownOpen(prevState => !prevState);
	};

	const fetchData = () => {
		const token = localStorage.getItem('token');
		if (token) {
			let URL = `${BASE_URL}/inspection/?page_no=${currentPage}&per_page=${perPage}`;

			if (params.size && params.get('property')) {
				URL += `&property_id=${params.get('property')}`;
			}
			if (searchQuery !== "") {
				URL += `&q=${searchQuery}`;
			}

			fetch(URL, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					console.log(data, 'data123')
					if (data.status) {
						const formattedInspections = data.result.data.map(inspection => {
							const formattedInspection = { ...inspection };
							formattedInspection.created_at = new Date(inspection.created_at).toLocaleDateString('en-US');

							formattedInspection.inspection_date = new Date(inspection.inspection_date).toLocaleDateString('en-US');
							return formattedInspection;
						});
						setInspections(formattedInspections);
						setTotalPages(data.result.meta_info.total_pages);
					} else {
						console.error("Error: Unable to fetch inspections data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	};


	const handleViewInspection = (id) => {
		navigate(`/inspection/view/${id}`, {
			state: {
				inspections: inspections
			}
		});
	};

	const handleGenerateReport = async (id) => {
		const token = localStorage.getItem('token');

		if (!token) {
			console.error('Error: Authorization token is missing.');
			return;
		}

		try {
			const response = await fetch(`${BASE_URL}/inspection/generate/${id}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});

			const data = await response.json();
			console.log(data, 'response');

			if (data.status) {
				const url = data.result;
				const newTab = window.open(url, '_blank');

				if (newTab) {
					newTab.document.title = 'Inspection Report';
				} else {
					console.error('Failed to open new tab');
				}
			} else {
				setErrMsg(data.message);
			}

		} catch (error) {
			console.error('Error generating PDF:', error);
			setErrMsg(error.message);
		}
	};

	const handlePageClick = (pageNumber) => {
		setCurrentPage(pageNumber);
	};

	const handlePerPageChange = (value) => {
		setPerPage(value);
		setCurrentPage(1);
	};

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join('-');
	};

	const deleteInspection = (id) => {
		if (window.confirm("Are you sure you want to delete this inspection?")) {
			const token = localStorage.getItem('token');
			if (token) {
				axios.delete(`${BASE_URL}/inspection/delete/${id}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
					.then(response => {
						const data = response.data;
						if (data.status) {
							fetchData();
						} else {
							console.error("Error: Unable to delete inspection.");
						}
					})
					.catch(error => console.error("Error fetching data:", error));
			} else {
				console.error("Error: Authorization token is missing.");
			}
		}
	}

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<Row>
				<Col xs="6">
					<h4 className="mt-0">Inspections</h4>
				</Col>
				<Col xs="6" className="text-end">
					{(checkPermission(USER_PERMISSIONS.CREATE_INSPECTION)) ? (
					<Button color="primary" onClick={() => setCreateInspection(true)}>Create Inspection</Button>
					) : null}
				</Col>
			</Row>

			<Card>
				<CardBody>
					<Row className="my-3">
						<Col xs="12" className="text-end">
							<Input
								type="text"
								placeholder="Search..."
								value={searchQuery}
								onChange={e => setSearchQuery(e.target.value)}
								style={{ display: 'inline-block', width: 'auto', marginRight: '10px' }}
							/>
						</Col>
					</Row>
					<Table >
						<thead>
							<tr>
								<th>#</th>
								<th>Property</th>
								<th>Created By</th>
								<th>Renter</th>
								<th>Type</th>
								<th>Inspection Date</th>
								<th>Created At</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{

								inspections.length === 0 ? (
									<tr>
										<td colSpan="8" className="text-center">
											No inspections available.
										</td>
									</tr>
								)
									:
									(
										inspections.map((inspection, index) => (
											<tr key={index}>
												<td>{(currentPage - 1) * perPage + index + 1}</td>
												<td>{inspection.property?.name}</td>
												<td>{inspection.created_by_name}</td>
												{/* <td>{inspection.tenant.first_name} {inspection.tenant.last_name}</td> */}
												<td>
													{inspection.tenants.map((tenant, i) => (
														<div key={i}>{tenant.first_name} {tenant.last_name}</div>
													))}
												</td>
												<td>{formatInspectionActivity(inspection?.activity)}</td>
												<td>{inspection.inspection_date}</td>
												<td>{inspection.created_at}</td>
												<td>
													<UncontrolledDropdown>
														<DropdownToggle
															caret
															color="primary"
														>
															Action
														</DropdownToggle>
														<DropdownMenu>
															{(checkPermission(USER_PERMISSIONS.VIEW_INSPECTION_REPORT)) ? (
															<>
															<DropdownItem onClick={() => handleViewInspection(inspection.id)}>
																View Details
															</DropdownItem>
															<DropdownItem onClick={() => handleGenerateReport(inspection.id)}>
																Generate Report
															</DropdownItem>
															<DropdownItem onClick={() => navigate(`/comparison-report-view`, {
																state: {
																	inspection_id: inspection.id,
																	property_id: inspection.property_id
																}
															})}>
																Select for Comparison
															</DropdownItem>
															</>	
															) : null}
															{(checkPermission(USER_PERMISSIONS.DELETE_INSPECTION)) ? (
															<>
															<DropdownItem divider />
															<DropdownItem onClick={() => deleteInspection(inspection.id)} className="text-danger">
																Delete
															</DropdownItem>
															</>
															) : null}
														</DropdownMenu>
													</UncontrolledDropdown>
													{/* <Button color="warning" onClick={() => handleViewInspection(inspection.id)}>View details</Button> */}
												</td>
											</tr>
										))
									)
							}
						</tbody>
					</Table>
				</CardBody>

				<Row>
					<Col xs="4">
						<div style={{ marginLeft: '25px' }}>
							<Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
								<DropdownToggle caret color="primary">
									Per Page: {perPage}
								</DropdownToggle>
								<DropdownMenu>
									<DropdownItem onClick={() => handlePerPageChange(5)}>5</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(10)}>10</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(20)}>20</DropdownItem>
									<DropdownItem onClick={() => handlePerPageChange(50)}>50</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</Col>

					<Col xs="8" className="text-right">
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'end', marginRight: '25px', marginTop: '10px' }}>
							<Pagination aria-label="Page navigation example">
								<PaginationItem disabled={currentPage === 1}>
									<PaginationLink

										previous
										onClick={() => handlePageClick(currentPage - 1)}
									/>
								</PaginationItem>

								{currentPage > 3 && (
									<>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(1)}>
												1
											</PaginationLink>
										</PaginationItem>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
									</>
								)}

								{Array.from({ length: 5 }, (_, i) => {
									const page = currentPage <= 3 ? i + 1 : currentPage - 2 + i;
									return (
										page <= totalPages && (
											<PaginationItem key={page} active={currentPage === page}>
												<PaginationLink

													onClick={() => handlePageClick(page)}
												>
													{page}
												</PaginationLink>
											</PaginationItem>
										)
									);
								})}

								{currentPage < totalPages - 2 && (
									<>
										<PaginationItem disabled>
											<PaginationLink>...</PaginationLink>
										</PaginationItem>
										<PaginationItem>
											<PaginationLink onClick={() => handlePageClick(totalPages)}>
												{totalPages}
											</PaginationLink>
										</PaginationItem>
									</>
								)}

								<PaginationItem disabled={currentPage === totalPages}>
									<PaginationLink

										next
										onClick={() => handlePageClick(currentPage + 1)}
									/>
								</PaginationItem>
							</Pagination>
						</div>
					</Col>
				</Row>
			</Card>

			{(createInspection) && (
				<AddInspectionPopup open={createInspection} setOpen={setCreateInspection} />
			)}
		</div>
	);
}

export default Inspection;
